import { getStoredLanguage } from './lang'

export const numberWithCommas = (x) => {
    return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
export const userPlaceholderImage = 'https://www.seekpng.com/png/detail/966-9665317_placeholder-image-person-jpg.png'

// Resolves the cookie / localStorage / browser default precedence chain.
// See utilities/lang.js for the full order. Module-level evaluation: callers
// that mutate the language at runtime should reload the page (the menu does).
export const userLanguage = getStoredLanguage()
export const userCountry = window.localStorage.getItem('country') || 'us'
export const linkColor = '#CAE4F1'
